import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://a5ecdc4f5cc1dd7adf6f8eb16467e130@o4511350891282432.ingest.us.sentry.io/4511350897704960',
  environment: process.env.NODE_ENV,
  // Only send errors in production — not during local dev
  enabled: process.env.NODE_ENV === 'production',
  // Capture 10% of sessions for performance — enough to spot slowdowns without volume cost
  tracesSampleRate: 0.1,
  // Strip lawyer names and case details from breadcrumbs
  beforeSend(event) {
    if (event.user) {
      delete event.user.email;
      delete event.user.username;
    }
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: '2rem', color: '#e8eaed' }}>Something went wrong. Please refresh the page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
